// Assets/search-autocomplete.js
(function () {
  const ID = 'ps-dropdown-fixed';

  // (선택) 인기검색어 JSON 뷰 엔드포인트 (메뉴/메타필드 기반)
  const POPULAR_ENDPOINT = '/search?view=popular';
  // 폴백(뷰가 없거나 실패 시 사용)
  const FALLBACK_POPULAR = ['프로틴', '비타민C', '오메가3', '마그네슘', '크레아틴'];

  let activeInput = null;
  let scrollParents = [];

  // 드롭다운(전역, body 밑) 생성
  function ensureDropdown() {
    let d = document.getElementById(ID);
    if (!d) {
      d = document.createElement('div');
      d.id = ID;
      Object.assign(d.style, {
        position: 'fixed',
        zIndex: '99999',
        background: '#fff',
        border: '1px solid #e9e9e9',
        borderRadius: '10px',
        boxShadow: '0 12px 30px rgba(0,0,0,.08)',
        overflowY: 'auto',
        maxHeight: '60vh',
        minWidth: '280px',
        display: 'none'
      });
      document.body.appendChild(d);

      // 드롭다운 내부 클릭 시 blur로 닫히는 것 방지(링크 클릭은 유지)
      d.addEventListener('mousedown', (e) => {
        if (!e.target.closest('a,[data-q]')) e.preventDefault();
      });

      // 🔹 인기검색어 칩 클릭 → 즉시 검색 이동
      d.addEventListener('click', (e) => {
        const chip = e.target.closest('[data-q]');
        if (!chip) return;
        e.preventDefault();
        const url = chip.getAttribute('data-url');
        const q = chip.getAttribute('data-q') || '';

        // 1) 테마의 검색 폼이 있으면 폼 제출(숨은 파라미터, 타입 제한을 그대로 활용)
        const form = document.querySelector('form[action*="/search"]');
        if (form && !url) {
          const input = form.querySelector('input[name="q"]');
          if (input) input.value = q;
          form.submit();
          return;
        }
        // 2) 아니면 URL로 바로 이동 (뷰에서 넘어온 url 우선)
        window.location.assign(url || `/search?q=${encodeURIComponent(q)}`);
      });
    }
    return d;
  }

  // 뷰포트에 맞춰 좌표/폭 보정
  function positionDropdown(input, d) {
    const rect = input.getBoundingClientRect();
    const margin = 6;
    const vw = window.innerWidth;
    const pad = 8;

    let width = Math.min(rect.width, vw - pad * 2);
    let left = rect.left;
    if (left + width > vw - pad) left = vw - pad - width;
    if (left < pad) left = pad;
    const top = Math.min(rect.bottom + margin, window.innerHeight - pad);

    Object.assign(d.style, { top: `${top}px`, left: `${left}px`, width: `${width}px`, display: 'block' });
  }

  // 스크롤 부모 모두 찾기
  function getScrollParents(el) {
    const arr = [window];
    let p = el.parentNode;
    while (p && p !== document.body) {
      const s = getComputedStyle(p);
      if (/(auto|scroll|overlay)/.test(s.overflow + s.overflowY + s.overflowX)) arr.push(p);
      p = p.parentNode;
    }
    return arr;
  }

  // 🔹 인기검색어 렌더(데이터 배열: [{text, url}] 사용)
  function renderPopular(d, items) {
    const chips = (items || []).map(i => `
      <button type="button" class="ps-chip" data-q="${i.text}"
              data-url="${i.url || ''}"
              style="display:inline-block;margin:6px;padding:8px 12px;border-radius:999px;
                     border:1px solid #e6e6e6;background:#f8f8f8;font-size:13px;cursor:pointer;">
        ${i.text}
      </button>
    `).join('');
    d.innerHTML = `
      <div style="padding:10px 12px;border-bottom:1px solid #f1f1f1;font-weight:600;font-size:13px">
        인기 검색어
      </div>
      <div style="padding:6px 6px 10px 6px">
        ${chips || '<div style="padding:10px;color:#777">등록된 인기 검색어가 없습니다.</div>'}
      </div>
    `;
  }

  // 🔹 인기검색어 표시(엔드포인트 → 폴백 순)
  async function showPopular(input, d) {
    let items = [];
    try {
      const res = await fetch(POPULAR_ENDPOINT, { headers: { Accept: 'application/json' } });
      if (res.ok) items = await res.json(); // 기대형태: [{text, url}]
    } catch (_) {}
    if (!Array.isArray(items) || items.length === 0) {
      items = FALLBACK_POPULAR.map(t => ({ text: t, url: `/search?q=${encodeURIComponent(t)}` }));
    }
    renderPopular(d, items);
    positionDropdown(input, d);
  }

  // 제품/페이지 결과 렌더
  function renderDropdown(d, data) {
    if (!Array.isArray(data) || data.length === 0) {
      d.innerHTML = '<div style="padding:12px;color:#777">결과 없음</div>';
      return;
    }
    d.innerHTML = data.map(i => `
      <a href="${i.url}" style="display:flex;gap:10px;align-items:center;padding:10px 12px;text-decoration:none">
        ${i.image ? `<img src="${i.image}" alt="" style="width:34px;height:34px;object-fit:cover;border-radius:8px;">` : ''}
        <div style="flex:1;min-width:0">
          <div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${i.title}</div>
          ${i.price ? `<small style="opacity:.7">${i.price}</small>` : ''}
        </div>
      </a>
    `).join('');
  }

  // 디바운스
  let timer;
  const deb = (fn, ms = 140) => (...a) => { clearTimeout(timer); timer = setTimeout(() => fn(...a), ms); };

  // API 호출 (제품 제안)
  async function fetchSuggest(input, d) {
    const q = input.value.trim();
    if (!q) { await showPopular(input, d); return; }
    positionDropdown(input, d);
    const url = `/search?view=autocomplete&q=${encodeURIComponent(q)}`;
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    const data = await res.json();
    renderDropdown(d, data);
    positionDropdown(input, d);
  }

  // 리스너 등록/해제
  function attachPositionWatch(input, d) {
    detachPositionWatch();
    scrollParents = getScrollParents(input);
    const onScroll = () => { if (d.style.display !== 'none') positionDropdown(input, d); };
    scrollParents.forEach(sp => sp.addEventListener('scroll', onScroll, { passive: true }));
    window.addEventListener('resize', onScroll, { passive: true });
    attachPositionWatch._onScroll = onScroll;
  }
  function detachPositionWatch() {
    if (!attachPositionWatch._onScroll) return;
    const onScroll = attachPositionWatch._onScroll;
    scrollParents.forEach(sp => sp.removeEventListener('scroll', onScroll));
    window.removeEventListener('resize', onScroll);
    attachPositionWatch._onScroll = null;
    scrollParents = [];
  }

  // 바인딩: 포커스된 검색 인풋 기준
  document.addEventListener('focusin', (e) => {
    const input = e.target.matches('form[action*="/search"] input[name="q"]') ? e.target : null;
    if (!input) return;

    activeInput = input;
    activeInput.setAttribute('autocomplete', 'off');

    const d = ensureDropdown();
    attachPositionWatch(activeInput, d);

    // 포커스 순간: 값이 비었으면 인기검색어, 있으면 제품 제안
    if (!activeInput.value.trim()) showPopular(activeInput, d);
    else fetchSuggest(activeInput, d);

    const onInput = deb(() => {
      if (!activeInput.value.trim()) showPopular(activeInput, d);
      else fetchSuggest(activeInput, d);
    });
    const onBlur = () => {
      setTimeout(() => {
        d.style.display = 'none';
        activeInput = null;
        detachPositionWatch();
        input.removeEventListener('input', onInput);
        input.removeEventListener('blur', onBlur);
      }, 120);
    };

    input.addEventListener('input', onInput);
    input.addEventListener('blur', onBlur);
  });

})();
